import ConfirmPopup from '~/components/shared/ConfirmPopup';
import { PostingType } from '~/enums/PostingType';

interface IOverlappingJobPopup {
  isOpen: boolean;
  /**
   * Accepted for back-compat with callers but no longer affects the rendered
   * popup — the copy now mentions both shifts and interviews.
   */
  jobPostingType?: PostingType;
  onConfirm?: () => void;
  onGoBack?: () => void;
}

const description =
  'At least 1 posting overlaps with an existing shift or onsite interview ' +
  'posted and/or confirmed. ' +
  'If you would like to review the dates, click "Go Back". ' +
  'If you wish to continue, click on "Confirm".';

export const OverlappingJobPopup = ({ isOpen, onConfirm, onGoBack }: IOverlappingJobPopup) => {
  if (!isOpen) {
    return null;
  }

  return (
    <ConfirmPopup
      title="Please Confirm"
      description={description}
      descriptionStyle={{ width: '76%', marginBottom: 50 }}
      leftButtonText="Go Back"
      leftButtonAction={onGoBack}
      rightButtonText="Confirm"
      rightButtonAction={onConfirm}
    />
  );
};
